import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, logoutBuilder } from '@modules/builders';

import walletActions from './actions';
import initialState from './state';
import type * as WalletTypes from './types';

export const walletReducer = createReducer(initialState, builder => {
  builder.addCase(walletActions.getTopupAddress.fulfilled, (state, action) => {
    state.topupAddressData[action.payload.data.currency] = action.payload.data;
  });

  builder.addCase(walletActions.getRapydPaymentMethods.fulfilled, (state, action) => {
    state.rapyd.methods = action.payload.data.methods?.map(method => ({
      id: method.type,
      label: method.name,
      icon: method.image,
    }));
  });
  builder.addMatcher(
    isAnyOf(walletActions.getWallet.fulfilled, walletActions.getWalletPolling.fulfilled),
    (state, action) => {
      state.data = action.payload.data;
    }
  );
  builder.addMatcher(
    isAnyOf(
      walletActions.getWalletLimits.fulfilled,
      walletActions.getWalletLimitsPolling.fulfilled
    ),
    (state, action) => {
      state.limits = action.payload.data;
    }
  );

  logoutBuilder(initialState, builder);
  loadersBuilder('wallet', builder);
});

export { walletActions, WalletTypes };
